import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'page-not-found',
  templateUrl: './pagenotfound.component.html',
})
export class PageNotFoundComponent {}
